<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.branch.branch') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.branch.branch'), href: '/branches' },
          { text: $t('administration.branch.edit'), active: true }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-3 col-md-5">
        <ts-card>
          <ts-card-wrapper>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <div id="img-frame" class="text-center">
                  <label for="logo_file" id="label_logo_file">
                    <img :src="logo_file_src" alt="" />
                  </label>
                  <input
                    type="file"
                    id="logo_file"
                    ref="logo_file"
                    accept="image/*"
                    @change="onFileSelected"
                  />
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.branch.company_name')
                  }}<span class="text-danger">*</span></label
                >
                <select
                  v-model.number="model.company_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('company_id') }"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option
                    v-for="(company, index) in companies"
                    :key="index"
                    :value="company.company_id"
                  >
                    {{ company.company_name_en }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('company_id')">
                  {{ errors.first('company_id') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.branch.code') }}
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  readonly
                  v-model="model.branch_code"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_code') }"
                />
                <div class="invalid-feedback" v-if="errors.has('branch_code')">
                  {{ errors.first('branch_code') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.branch.prefix') }}
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  v-model="model.prefix"
                  readonly
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('prefix') }"
                />
                <div class="invalid-feedback" v-if="errors.has('prefix')">
                  {{ errors.first('prefix') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.branch.name_en')
                  }}<span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  v-model="model.branch_name_en"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_name_en') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('branch_name_en')"
                >
                  {{ errors.first('branch_name_en') }}
                </div>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-sm-12 col-lg-9 col-md-7">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.name_kh')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.branch_name_kh"
                      class="form-control kh-font"
                      :class="{ 'is-invalid': errors.has('branch_name_kh') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('branch_name_kh')"
                    >
                      {{ errors.first('branch_name_kh') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">
                    {{ $t('administration.branch.phone') }}</label
                  >
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.phone"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('phone') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('phone')">
                      {{ errors.first('phone') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.email')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="email"
                      v-model="model.email"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('email') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('email')">
                      {{ errors.first('email') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10" style="margin-top: -2px">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.facebook_page')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.facebook_page"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('facebook_page') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('facebook_page')"
                    >
                      {{ errors.first('facebook_page') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10" style="margin-top: -2px">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.facebook_link')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.facebook_link"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('facebook_link') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('facebook_link')"
                    >
                      {{ errors.first('facebook_link') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10" style="margin-top: -2px">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.web_site')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.website"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('website') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('website')">
                      {{ errors.first('website') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <ts-checkbox
                    v-model="model.is_head"
                    style="margin: 1% 0 0 12px"
                    >{{ $t('administration.branch.head_office') }}</ts-checkbox
                  >
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="row orm-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.feacebookLink')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="model.facebook_link"
                    />
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.googleAddress')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.google_add_pin"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('address') }"
                      rows="10"
                    />
                    <div class="invalid-feedback" v-if="errors.has('address')">
                      {{ errors.first('address') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.telegram')
                  }}</label>
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model="model.telegram_number"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="row form-group m-b-10">
                  <label class="col-form-label control-label">{{
                    $t('administration.branch.address')
                  }}</label>
                  <div class="col-md-12">
                    <textarea
                      v-model="model.address"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('address') }"
                      rows="10"
                    ></textarea>
                    <div class="invalid-feedback" v-if="errors.has('address')">
                      {{ errors.first('address') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-12 col-lg-12 col-md-12 text-right">
                <ts-button
                  color="primary"
                  :waiting="waiting"
                  @click.prevent="update"
                >
                  {{ $t('administration.branch.update') }}
                </ts-button>
                <ts-button
                  class="ml-2"
                  @click.prevent="$router.push({ name: 'branch' })"
                  >{{ $t('administration.branch.cancel') }}</ts-button
                >
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'branch-edit',
  data() {
    return {
      model: {
        branch_id: '',
        company_id: '',
        branch_code: '',
        branch_name_kh: '',
        branch_name_en: '',
        phone: '',
        email: '',
        website: '',
        address: '',
        prefix: '',
        is_head: '',
        facebook_page: '',
        facebook_link: '',
        google_add_pin: '',
        telegram_number: ''
      },
      errors: new Errors(),
      waiting: false,
      file: '',
      logo_file_src:
        'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('branch', ['edit_data', 'companies'])
  },
  methods: {
    onFileSelected() {
      const file = this.$refs.logo_file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.logo_file_src =
            'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'

          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },

    uploadfile() {
      this.file = this.$refs.logo_file.files[0]
        ? this.$refs.logo_file.files[0]
        : null
      if (this.file) {
        let formData = new FormData()
        formData.append('image_logo', this.file)
        return this.$store.dispatch('branch/uploadLogo', formData)
      }

      return this.edit_data.image_logo
    },
    setEditData() {
      this.model.branch_id = this.edit_data.branch_id
      this.model.company_id = this.edit_data.company_id
      this.model.branch_code = this.edit_data.branch_code
      this.model.branch_name_kh = this.edit_data.branch_name_kh
      this.model.branch_name_en = this.edit_data.branch_name_en
      this.model.phone = this.edit_data.phone
      this.model.email = this.edit_data.email
      this.model.website = this.edit_data.website
      this.model.address = this.edit_data.address
      this.model.prefix = this.edit_data.prefix
      this.model.image_logo = this.edit_data.image_logo
      this.model.is_head = this.edit_data.is_head
      this.model.facebook_page = this.edit_data.facebook_page
      this.logo_file_src = this.edit_data.image_logo
      this.facebook_link = this.edit_data.facebook_link
      this.model.google_add_pin = this.edit_data.google_add_pin
      this.model.telegram_number = this.edit_data.telegram_number
    },
    async update() {
      this.errors = new Errors()
      this.waiting = true
      let file_upload_path = await this.uploadfile()

      this.$store
        .dispatch(
          'branch/update',
          Object.assign({}, this.model, { image_logo: file_upload_path })
        )
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'branch' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },

  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('branch/RESET_STATE')
      this.$store.commit('branch/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>
<style scoped>
#logo_file {
  display: none;
}
#img-frame img {
  object-fit: contain;
  width: 165px;
  height: 142px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
  border-radius: 10px;
  padding: 5px;
}
#label_logo_file {
  cursor: pointer;
}
</style>
